module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/process/process-01-6ecc1e84272878c4e6d416d616256d8f.svg";